export abstract class DocumentRef {
  head: any;
  document: any;
  body: any;
  location?: Location;

  abstract setCookie(cname: string, cvalue: string, exdays: number): void;
  abstract getCookie(cname: string): string;
}
